import type React from 'react';
import type { QuickFillRowMode } from '../../../shared/types';
import type { ActionBarProps } from '../ui/components';

export interface BuildQuickFillActionBarPropsInputs {
  totalRows: number;
  selectedRowCount: number;
  keyLibraryRowsReady: boolean;
  selectedCellCount: number;
  activeColumnLabel: string | null;
  fillDownTargetCount: number;
  modelSelectionCount: number;
  rowMode: QuickFillRowMode;
  isColumnsPanelOpen: boolean;
  modelDataStale: boolean;
  refs: {
    autoFillControlsRef: React.RefObject<HTMLDivElement | null>;
    manageColumnsRef: React.RefObject<HTMLButtonElement | null>;
    findReplaceRef: React.RefObject<HTMLButtonElement | null>;
    rowModeToggleRef: React.RefObject<HTMLLabelElement | null>;
    modelSelectRef: React.RefObject<HTMLButtonElement | null>;
    csvToolsRef: React.RefObject<HTMLDivElement | null>;
    utilityToolsRef: React.RefObject<HTMLDivElement | null>;
  };
  handlers: {
    onAutoFillAll: () => void;
    onAutoFillSelected: () => void;
    onAddToKeyLibrary: () => void;
    onCopy: () => void;
    onPaste: () => void;
    onClear: () => void;
    onClearColumn: () => void;
    onFillDown: () => void;
    onFindReplace: () => void;
    onExport: () => void;
    onImport: () => void;
    onAddColumns: () => void;
    onRefreshModel: () => void;
    onSelectInModel?: () => void;
    onToggleRowMode?: (checked: boolean) => void;
  };
}

/**
 * Pure builder for the Quick Fill action bar props.
 *
 * Keeps the page from constructing the ActionBar prop object inline and makes
 * the mapping easy to unit-test.
 */
export function buildQuickFillActionBarProps(
  inputs: BuildQuickFillActionBarPropsInputs
): ActionBarProps {
  const {
    totalRows,
    selectedRowCount,
    keyLibraryRowsReady,
    selectedCellCount,
    activeColumnLabel,
    fillDownTargetCount,
    modelSelectionCount,
    rowMode,
    isColumnsPanelOpen,
    modelDataStale,
    refs,
    handlers,
  } = inputs;

  return {
    totalRows,
    selectedRowCount,
    keyLibraryRowsReady,
    selectedCellCount,
    activeColumnLabel,
    fillDownTargetCount,
    modelSelectionCount,
    rowMode,
    isColumnsPanelOpen,
    modelDataStale,
    ...refs,
    ...handlers,
  };
}
